import React, {
    useEffect,
    useState
} from 'react';
import PropTypes from "prop-types";
import {Resources} from "app/app.resource";
import {Translate} from "app/services/translate";
import {CurrencySelect} from "../amounts/currencySelect";
import {Arrow} from "../amounts/arrow";

const SHOWN_CURRENCIES_OUT = ['PLN', 'EUR', 'GBP', 'USD'];

export const ExchangeRates = ({availableCurrenciesIn, availableCurrenciesOut, currency, onCurrencyChange}) => {
    const [exchangeRates, setExchangeRates] = useState([]);

    useEffect(() => {
        Promise.all(
            availableCurrenciesOut
                .filter(curr => SHOWN_CURRENCIES_OUT.includes(curr))
                .map(currencyOut => Resources.getExchangeRate(currency, currencyOut, 50000))
        ).then(exchanges => {
            setExchangeRates(
                exchanges.map(({data}) => data.attributes),
            );
        });
    }, [currency]);

    return (
        <div className="rates-wrapper">
            <h2 className="heading">{Translate('calculator_keep_up_to_date')}</h2>
            <div className="wrapper">
                <div className="currency-in">
                    <CurrencySelect
                        type="currencyIn"
                        value={currency}
                        currencies={availableCurrenciesIn}
                        onChange={onCurrencyChange}
                        useFullName/>
                </div>
                <div className="arrow">
                    <Arrow/>
                </div>
                <div className="currencies-out">
                    {exchangeRates.map(exchangeRate => (
                        <div className="currency" key={exchangeRate.currency_base + exchangeRate.currency_quoted}>
                            <i className={`flag-icon flag-icon-squared flag-icon-${exchangeRate.currency_quoted.toLowerCase().substr(0, 2)}`}/>
                            {exchangeRate.rate.toFixed(4)} {exchangeRate.currency_quoted}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
ExchangeRates.propTypes = {
    availableCurrenciesIn: PropTypes.arrayOf(PropTypes.string).isRequired,
    availableCurrenciesOut: PropTypes.arrayOf(PropTypes.string).isRequired,
    currency: PropTypes.string.isRequired,
    onCurrencyChange: PropTypes.func,
}